import { gql } from '@apollo/client';
const UPDATE_TENANT_BRAND = gql `
  mutation UpdateTenantBrand($brandId: ID!, $name: String!) {
    updateBrand(brandId: $brandId, name: $name) {
      brand {
        id
        name
      }
    }
  }
`;
export default UPDATE_TENANT_BRAND;
